"use client";

import { auth } from "@vionixasia/shared-components/lib/firebase";

export async function apiClient<T>(path: string, options: RequestInit = {}): Promise<T> {
  let token: string | undefined;
  try {
    token = await auth.currentUser?.getIdToken();
  } catch {
    token = undefined;
  }
  const apiBaseUrl = (import.meta.env.VITE_API_BASE_URL || "https://vionix-backend.fly.dev").replace(/\/$/, "");
  const url = `${apiBaseUrl}${path}`;

  const response = await fetch(url, {
    ...options,
    headers: {
      ...(options.body instanceof FormData ? {} : { "Content-Type": "application/json" }),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {}),
    },
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data?.error || `Request failed: ${response.status}`);
  }
  return data as T;
}
